export default function initLazyBackgrounds() {
  if (typeof window === "undefined") return;

  const selector = "[data-bg]";
  const loadBg = (el) => {
    const src = el.dataset.bg;
    if (!src) return;
    try {
      el.style.backgroundImage = `url(${src})`;
      el.setAttribute("data-bg-loaded", "true");
    } catch (e) {
      // ignore
    }
  };

  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(selector).forEach(loadBg);
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadBg(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "200px 0px" },
  );

  document.querySelectorAll(selector).forEach((el) => {
    // if already inline-loaded, skip
    if (el.getAttribute("data-bg-loaded") === "true") return;
    io.observe(el);
  });
}
